export const AppSettings = Object.freeze({
    "SERVER_URL": 'https://mobile-api.atarix.co.il/matnasNetApi/api/',
    "APP_VERSION": 'https://mobile-api.atarix.co.il/matnasNetApi/app_version.php',
    "RAMATGANEMONAL_URL": 'https://www.mbe-rg.co.il/matnasNetApi/api/',
    "RAMATGANEMONAL_DOMAIN": 'https://www.mbe-rg.co.il/',
    "SECURITY_KEY": '',
    "FACEBOOKID": '',
    "TOAST": {
        "duration": 3000,
        "position": "buttom"
    },
});


// WEBPACK FOOTER //
// ./src/services/app-settings.ts